export const SET_COUNTER = "SET_COUNTER";

export function setLastUpdateCounter(value) {
    return {
        type: SET_COUNTER,
        value: value,
    };
}
